import I18n from 'I18n';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UIIllustration from 'UIComponents/image/UIIllustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H1 } from 'UIComponents/elements/headings';
import TwoFactorAuthMethod from '../../constants/twoFactorAuthMethod';
import Blob from '../../utils/Blob';
import TestIds from '../../constants/testIDs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PromptWrapper = ({
  currentAuthMethod,
  currentObfuscatedInfo,
  children
}) => {
  const headerText = () => /*#__PURE__*/_jsx(FormattedMessage, {
    message: currentAuthMethod ? `reAuth.headerTexts.${currentAuthMethod}` : 'reAuth.defaultExplanation',
    options: {
      obfuscatedInfo: currentObfuscatedInfo
    }
  });
  const renderIllustration = () => {
    let illustrationName = 'keys';
    if (currentAuthMethod === TwoFactorAuthMethod.HUBSPOT_AUTHENTICATOR) {
      illustrationName = 'mobile-notify';
    }
    return /*#__PURE__*/_jsx(UIIllustration, {
      name: illustrationName,
      width: '40%'
    });
  };
  return /*#__PURE__*/_jsxs(UIFlex, {
    direction: "row",
    justify: "center",
    align: "center",
    wrap: "wrap",
    width: "100",
    className: "p-all-10",
    "data-test-id": "two_factor_prompt",
    "aria-label": `${I18n.text('reAuth.defaultExplanation')} ${currentAuthMethod ? I18n.text(`reAuth.headerTexts.${currentAuthMethod}`, {
      obfuscatedInfo: currentObfuscatedInfo
    }) : ''}`,
    children: [/*#__PURE__*/_jsxs(UIBox, {
      basis: 545,
      children: [/*#__PURE__*/_jsx(H1, {
        "data-test-id": TestIds.HEADER,
        children: headerText()
      }), currentAuthMethod !== undefined && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.defaultExplanation"
      }), children]
    }), /*#__PURE__*/_jsx(UIBox, {
      children: /*#__PURE__*/_jsx(Blob, {
        renderComponent: renderIllustration
      })
    })]
  });
};
export default PromptWrapper;